import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/expedientes-de-comercio-informal/';

/**
 * GET ExpedienteExpedientesInformales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getExpedientesInformales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET ExpedienteComercioInformal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExpedienteComercioInformal = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ExpedienteComercioInformal
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExpedienteComercioInformal = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ExpedienteComercioInformal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchExpedienteComercioInformal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values, { clean: false }));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ExpedienteComercioInformal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExpedienteComercioInformal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Expedientes de Comercio Informal para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getExpedientesDeComercioCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/expedientes-de-comercio-informal-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
